import { root } from './locations';

export const locations = {
  ...root,
};
